var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chats"},_vm._l((_vm.chats),function(chat){return _c('the-min-corpo-chat',{key:chat.id,attrs:{"id":chat.id,"chat":chat}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }